import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { flatDocOrder, defaultUrlFor } from '../config/manifest';

interface Props {
  groupId: string;
  slug: string;
}

export default function DocPrevNext({ groupId, slug }: Props) {
  const flat = flatDocOrder();
  const idx = flat.findIndex((d) => d.groupId === groupId && d.slug === slug);
  const prev = idx > 0 ? flat[idx - 1] : null;
  const next = idx >= 0 && idx < flat.length - 1 ? flat[idx + 1] : null;

  if (!prev && !next) return null;

  return (
    <nav className="prevnext" aria-label="Previous and next documents">
      {prev ? (
        <Link to={defaultUrlFor(prev.groupId, prev.slug)} className="prevnext__btn prevnext__prev">
          <span className="prevnext__label">
            <ChevronLeft className="prevnext__icon" aria-hidden="true" />
            Previous
          </span>
          <span className="prevnext__title">{prev.title}</span>
        </Link>
      ) : (
        <span className="prevnext__spacer" />
      )}
      {next ? (
        <Link to={defaultUrlFor(next.groupId, next.slug)} className="prevnext__btn prevnext__next">
          <span className="prevnext__label">
            Next
            <ChevronRight className="prevnext__icon" aria-hidden="true" />
          </span>
          <span className="prevnext__title">{next.title}</span>
        </Link>
      ) : (
        <span className="prevnext__spacer" />
      )}
    </nav>
  );
}
